import * as Yup from 'yup'
import { nationalPhoneSchema } from '@services/phone'

const fullSchema = Yup.object().shape({
  isDraft: Yup.boolean(),
  name: Yup.string().required('Name is required'),
  email: Yup.string().required('Email is required').email('Invalid email format'),
  nik: Yup.string().required('NIK is required').length(16, 'NIK must be 16 digits'),
  jenis_kelamin: Yup.string().required('Gender is required'),
  telepon: nationalPhoneSchema(Yup),
  tempat_lahir: Yup.string().required('Place of birth is required'),
  tanggal_lahir: Yup.date().nullable().required('Date of birth is required'),
  kode_pos: Yup.string()
    .required('Postal code is required')
    .matches(/^\d{5}$/, 'Postal code must be 5 digits'),
  kota: Yup.object().nullable().required('City is required'),
  kecamatan: Yup.object().nullable().required('District is required'),
  kelurahan: Yup.object().nullable().required('Subdistrict is required'),
  alamat: Yup.string().required('Address is required'),
  penjelasan: Yup.string().required('Explanation is required'),
  nama_ibu: Yup.string().required("Mother's maiden name is required"),
  agreement: Yup.boolean().oneOf([true], 'You must tick the agreement'),
  tujuan_permintaan: Yup.object().nullable().required('Request purpose is required'),
  photo: Yup.mixed().nullable().required('KTP photo is required'),
  photo_selfie: Yup.mixed().nullable().required('Selfie with KTP is required'),
  signature: Yup.mixed().nullable().required('Signature is required'),
})

const draftSchema = Yup.object().shape({
  isDraft: Yup.boolean(),
  name: Yup.string().nullable(),
  email: Yup.string().nullable().email('Invalid email format'),
  nik: Yup.string().nullable(),
  jenis_kelamin: Yup.string().nullable(),
  telepon: Yup.string().nullable(),
  tempat_lahir: Yup.string().nullable(),
  tanggal_lahir: Yup.date().nullable(),
  kode_pos: Yup.string().nullable(),
  kota: Yup.object().nullable(),
  kecamatan: Yup.object().nullable(),
  kelurahan: Yup.object().nullable(),
  alamat: Yup.string().nullable(),
  penjelasan: Yup.string().nullable(),
  nama_ibu: Yup.string().nullable(),
  agreement: Yup.boolean(),
  tujuan_permintaan: Yup.object().nullable(),
  photo: Yup.mixed().nullable(),
  photo_selfie: Yup.mixed().nullable(),
  signature: Yup.mixed().nullable(),
})

export const schema = Yup.lazy((values) => (values?.isDraft ? draftSchema : fullSchema))

export const schemaImport = Yup.object().shape({
  samcards: Yup.mixed()
    .required()
    .test('fileSize', 'The file is too large', (value) => value.size <= 200000000),
})
